import { useStorageAsync } from '@vueuse/core';
import { ref } from 'vue';

const KEY = 'redirect-path';
const redirectPath = useStorageAsync(KEY, ref<string | null>(null), sessionStorage);

export function storeRedirectPath(path: string): void {
  redirectPath.value = `${path}`;
}

export function loadRedirectPath(): string | null {
  return redirectPath.value;
}

export function clearRedirectPath(): void {
  redirectPath.value = null;
}
